import { Spin } from 'antd'
import React, { FunctionComponent } from 'react'

import { PROPERTY_TYPES } from '../../../common/drmTypes'
import { useAppSelector } from '../../../redux/hooks'
import { useCheckClaims } from '../../utils/useCheckClaims'
import { PropertyDetailSidebarContainer } from '../PropertyDetailSidebarContainer/PropertyDetailSidebarContainer'
import { PropertyDetailSidebarPriceUnit } from '../PropertyDetailSidebarPriceUnit/PropertyDetailSidebarPriceUnit'

export interface PropertyDetailSidebarPriceProps {
  isDrawer?: boolean
}

export const PropertyDetailSidebarPrice: FunctionComponent<PropertyDetailSidebarPriceProps> =
  ({ isDrawer }) => {
    const crmDrmData = useAppSelector(state => state.property.crm.data)
    const priceFetching = useAppSelector(state => state.property.price.fetching)
    const {
      data: ruianDetail,
      fetching,
      error,
    } = useAppSelector(state => state.property.ruian)

    const tester = useCheckClaims('ApiVyvojar')

    if (
      error ||
      !tester ||
      ruianDetail?.type !== PROPERTY_TYPES.UNIT ||
      crmDrmData === false
    )
      return null

    return (
      <PropertyDetailSidebarContainer isDrawer={isDrawer}>
        <Spin spinning={fetching || priceFetching}>
          <div className="flex flex-col space-y-2 animate-fadeIn">
            {fetching || priceFetching ? (
              <div>Informace o cenách...</div>
            ) : (
              ruianDetail?.type === PROPERTY_TYPES.UNIT && (
                <PropertyDetailSidebarPriceUnit isDrawer={isDrawer} />
              )
            )}

            {/*             
            {ruianDetail?.type === PROPERTY_TYPES.BUILDING && ()}
            {ruianDetail?.type === PROPERTY_TYPES.AREA && ()}
            */}
          </div>
        </Spin>
      </PropertyDetailSidebarContainer>
    )
  }
